type CreateOnScanHandlerOptions = {
    shouldProcess?: () => boolean;
    onNormalizedScan: (normalized: string) => Promise<void> | void;
};

const normalizeScannerValue = (raw: string) => raw.replace(/[\s\uFEFF\u00A0\u200B-\u200D\u2060]+/g, '');

export const createOnScanHandler = ({ shouldProcess, onNormalizedScan }: CreateOnScanHandlerOptions) => {
    return async (raw: string) => {
        const normalized = normalizeScannerValue(raw);
        if (!normalized) return;

        if (shouldProcess && !shouldProcess()) {
            return;
        }

        await onNormalizedScan(normalized);
    };
};
